module.exports = __webpack_public_path__ + "static/media/img191.a45e0c14.jpg";